import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import type { OrderLineItem } from "@babackapp/return-widget-components/types";

// `nonReturnableReason` is absent when an override rule is what blocks the
// article: that rule carries no wording, so the label stays generic.
export function useNonReturnableLabel(): (lineItem: OrderLineItem) => string {
  const t = useCustomText();

  return (lineItem) =>
    lineItem.nonReturnableReason === "OUTSIDE_RETURN_WINDOW"
      ? t("articleSelection.outsideReturnWindow")
      : t("articleSelection.notReturnable");
}
